import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.css";
import { validateEmail, validatePassword } from "../../utils/Formatter";
import Check from "../../icons/Check";

const Input = ({ value, onChangeText, placeholder, type, children, containerStyle, ...rest }) => {
  const [isFocused, setFocused] = useState(false);
  const initialized = useRef(false)

  function isValid(text = value) {
    if (type === "email") return validateEmail(text);
    if (type === "password") return validatePassword(text);
    return rest?.isValid || false;
  }

  useEffect(() => {
    if (value && !initialized.current) {
      onChangeText(value, isValid(value))
      initialized.current = true
    }
  }, [value])

  return (
    <div
      className={`${"input-container"} ${isFocused ? " typingContainer" : ""
        }`}
      style={containerStyle}
    >
      <input
        className={"sub-input"}
        value={value}
        type={type}
        placeholder={placeholder}
        onChange={(e) => onChangeText(e.target.value, isValid(e.target.value))}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...rest}
      />
      <div className={"iconContainer"}>
        {children ? children : isValid() ? <Check /> : null}
      </div>
    </div>
  );
};

export default Input;
